import { Outlet } from "react-router-dom";
import PsikotesNavbar from "./PsikotesNavbar";
import PsikotesFooter from "./PsikotesFooter";
import { useSelector } from "react-redux";

const PsikotesLayout = () => {
  const { page, start, timer } = useSelector((state) => state.psikotesNavbar);
  return (
    <>
      <PsikotesNavbar page={page} start={start} timer={timer} />

      <div className="min-h-screen bg-gray-300 px-5 md:px-10 lg:px-14 py-12 w-full">
        <div className="w-full bg-white mb-4 py-4 rounded-lg text-black text-center text-xl font-semibold">
          SOAL {page?.toUpperCase()}
        </div>

        <Outlet />
      </div>

      <PsikotesFooter />
    </>
  );
};

export default PsikotesLayout;
